<template>
  <div class="topBar">
    <ul>
      <li class="firstTitle">
        {{ title }}
      </li>
    </ul>
    <userTop></userTop>
  </div>
</template>

<script>
import UserTop from './UserTop.vue'
export default {
  name: 'TopBar',
  props: {
    title: String
  },
  components: {
    userTop: UserTop
  }
}
</script>

<style scoped lang="sass">
.topBar
  display: flex
  height: 40px
  padding: 15px 0
  align-items: center
  ul
    display: flex
    flex-grow: 1
    margin: 0
    padding: 0
    margin-left: 30px
    height: 40px
    li.firstTitle
      font-size: 16px
      font-weight: 400
      border-left: 0
    li
      list-style: none
      height: 24px
      padding: 0 30px
      margin: 8px 0
      line-height: 24px
      color: #666
      border-left: 1px solid #aaa
      font-size: 14px
      cursor: pointer
</style>



// WEBPACK FOOTER //
// src/topdoor/components/TopBar.vue